export default __webpack_public_path__ + "media/images/react_icons/paper_search_landlord-5ec6c2a2bc8a4eb9354878c07a87d7ba.svg";